import * as React from "react";

export const Reports = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.40002 2.50002C1.40002 1.89251 1.89251 1.40002 2.50002 1.40002H5.50002C6.10754 1.40002 6.60002 1.89251 6.60002 2.50002V4.40002H9.50002C10.1075 4.40002 10.6 4.89251 10.6 5.50002V7.40002H13.5C14.1075 7.40002 14.6 7.89251 14.6 8.50002V13C14.6 13.8837 13.8837 14.6 13 14.6L10.6 14.6H10L9.40002 14.6L6.60002 14.6H6.00002H5.40002H3.00002C2.11637 14.6 1.40002 13.8837 1.40002 13V2.50002ZM9.40002 13.4V8.50002V5.60002H6.60002V8.00002V13.4H9.40002ZM10.6 13.4H13C13.2209 13.4 13.4 13.2209 13.4 13V8.60002H10.6V13.4ZM5.40002 2.60002V5.50002V8.00002V13.4H3.00002C2.77911 13.4 2.60002 13.2209 2.60002 13V2.60002H5.40002Z"
    />
);
